import type {
  AnalyticsEventDefinition,
  EventInput,
} from '../models/event.models';

/**
 * Fills in `tab` and `section` for a group of events, eliminating repetition.
 * Keys are set by the caller, so existing event key names are preserved.
 *
 * Usage:
 *   export const MY_TAB_EVENTS = defineSectionEvents('My Tab', 'Table', {
 *     MY_TAB_DEAL_SELECTED: { action: 'Deal Selected', description: '...' },
 *   });
 *
 *   // Multiple sections in one tab:
 *   export const MY_TAB_EVENTS = {
 *     ...defineSectionEvents('My Tab', 'Table', { ... }),
 *     ...defineSectionEvents('My Tab', 'Details', { ... }),
 *   };
 */
export function defineSectionEvents<T extends Record<string, EventInput>>(
  tab: string,
  section: string,
  events: T
): { [K in keyof T]: AnalyticsEventDefinition } {
  return Object.fromEntries(
    Object.entries(events).map(([key, def]) => [key, { tab, section, ...def }])
  ) as { [K in keyof T]: AnalyticsEventDefinition };
}
